import { ChatVisibility, SettingsObject } from "../VoiceChat/components/VoiceChat/fictiveTypes";

const migrateChatLogVisibility = (settings: SettingsObject): SettingsObject => {
  if (settings.chatLogVisibility !== undefined) {
    return settings;
  }

  const newSettings = { ...settings };

  if (settings.disableChatLog) {
    newSettings.chatLogVisibility = ChatVisibility.Disabled;
  } else if (settings.disableChatLog === false) {
    newSettings.chatLogVisibility = ChatVisibility.Shown;
  }

  return newSettings;
};

const migrateChatInputVisibility = (settings: SettingsObject): SettingsObject => {
  if (settings.chatInputVisibility !== undefined) {
    return settings;
  }

  const newSettings = { ...settings };

  if (settings.disableTextInput) {
    newSettings.chatInputVisibility = ChatVisibility.Disabled;
  } else if (settings.disableTextInput === false) {
    newSettings.chatInputVisibility = ChatVisibility.Shown;
  }

  return newSettings;
};

const migrations = [
  migrateChatLogVisibility,
  migrateChatInputVisibility,
  // future migrations here
];

// This function applies all migrations in sequence to the given settings object
export const migrateSettings = (settings: SettingsObject): SettingsObject => {
  return migrations.reduce((acc, migrate) => migrate(acc), settings);
};
